export default __webpack_public_path__ + "static/media/16.09c58f92.jpg";